// @flow strict
import { useStaticQuery, graphql } from "gatsby"

const useRackets = () => {
  const { rackets } = useStaticQuery(
    graphql`
      query Rackets {
        rackets: allMdx(
          filter: {
            internal: {
              contentFilePath: { regex: "/content/(racket|string|grip)/" }
            }
          }
        ) {
          nodes {
            internal {
              contentFilePath
            }
            fields {
              slug
            }
            frontmatter {
              title
              name
              jp
              url
              amazon
              rakuten
              brand
              year
              asin
              thumbnail {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    `
  )

  return rackets
}

export default useRackets
